import { Chatbot } from "../../model/chatbot/Chatbot";
import { CreateChatbotDto } from "../../model/chatbot/dto/CreateChatbotDto";
import { DeleteChatbotDto } from "../../model/chatbot/dto/DeleteChatbotDto";
import { UpdateChatbotDto } from "../../model/chatbot/dto/UpdateChatbotDto";
import { GenericWithUserId } from "../../model/shared/dto/GenericWithUserId";
import { AtiraApi } from "../AxiosClient";

export class ChatbotAxios {
  static async createChatbot(dto: CreateChatbotDto) {
    return AtiraApi.post<void>(`/chatbot/create`, dto).then(({ data }) => data);
  }

  static async getChatbots(dto: GenericWithUserId) {
    return AtiraApi.post<Chatbot[]>(`/chatbot/user/${dto.userId}`, dto).then(
      ({ data }) => data,
    );
  }

  static async deleteChatbot(dto: DeleteChatbotDto) {
    return AtiraApi.delete<void>(`/chatbot/${dto.chatbotId}`, {
      data: dto,
    }).then(({ data }) => data);
  }

  static updateChatbot(dto: UpdateChatbotDto) {
    return AtiraApi.patch<void>(`/chatbot/${dto.chatbotId}`, dto).then(
      ({ data }) => data,
    );
  }
}
